/*
 * Bloques `write` de las lecturas (F2a). Archivo aparte para que `metaCampaigns` y
 * `metaAdsConnection` los lean sin depender de `metaWrite` (evita imports circulares).
 */
const bool = (v) => v === true;
const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);
const int = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : null;
};

const BUDGET_LEVELS = ['campaign', 'adset', 'none'];

/**
 * Bloque `write` de una campaña / anuncio de `getmetacampaigns` o de un conjunto de `getmetaadsets` (§7).
 * `null` = no vino (sin escritura). Los flags nuevos (presupuesto, fecha, archivar, eliminar) faltan en
 * una API vieja → `false` (no se muestra nada nuevo).
 */
export function readMetaWriteBlock(raw) {
  if (!raw || typeof raw !== 'object') return null;
  return {
    canPause: bool(raw.can_pause),
    canResume: bool(raw.can_resume),
    canRename: bool(raw.can_rename),
    canEditBudget: bool(raw.can_edit_budget),
    budgetLevel: BUDGET_LEVELS.includes(raw.budget_level) ? raw.budget_level : null,
    canEditEndTime: bool(raw.can_edit_end_time),
    canArchive: bool(raw.can_archive),
    canDelete: bool(raw.can_delete),
    realMoney: raw.real_money !== false,
    reason: str(raw.reason),
  };
}

/** Bloque `write` de `getmetaconnection` (§3.1). `null` = no vino. */
export function readMetaConnectionWrite(raw) {
  if (!raw || typeof raw !== 'object') return null;
  return {
    available: raw.available !== false,
    reason: str(raw.reason),
    scopeGranted: bool(raw.scope_granted),
    killSwitch: bool(raw.kill_switch),
    accountsEnabledCount: int(raw.accounts_enabled_count) || 0,
    viewerCanWrite: bool(raw.viewer_can_write),
  };
}

